import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { useContext, useState } from 'react'
import { BiTrash } from 'react-icons/bi'
import { FaPersonCircleCheck } from 'react-icons/fa6'
import { IoReload } from 'react-icons/io5'
import { LuSave } from 'react-icons/lu'
import dayjs from 'dayjs'
import { metodoPrograma } from '../../../../../../components/api'
import { AgendaContext } from '../../..'
import { GlobalContext } from '../../../../../../App'
import { setSuccess } from '../../../../../../components/alerts'
import { useModal } from '../../../../../../components/Utils/UseModal'
import ModalConfirmacaoSenha from './ModalConfirmacaoSenha'

export function Actions({
  tpEstado,
  idAgendamento,
  dtExclusao,
  dtConfirmouComparecimento,
  fecharModal,
}) {
  const { agendamentoSelecionado } = useContext(AgendaContext)
  const { localAtendimento, usuarioLogado } = useContext(GlobalContext)
  const openModalSenha = useModal(ModalConfirmacaoSenha)
  const [openConfirmModal, setOpenConfirmModal] = useState(false)
  const mensageSendWhats = `Você confirma sua presença na consulta com a Clínica, agendada para o dia ${dayjs(agendamentoSelecionado.data?.[1]).format('DD/MM/YYYY')}, às ${dayjs(agendamentoSelecionado.data?.[1]).format('HH:mm')}?`

  const cancelaAgendamento = (idAgendamento) => {
    metodoPrograma('cancelaAgendamento', { idAgendamento }).then((res) => {
      if (res.status) {
        fecharModal()
      }
    })
  }

  const handleSendWhatsApp = async () => {
    const nrTelefone = agendamentoSelecionado.data?.[14]
    const result = await metodoPrograma(
      'enviaWhats',
      {
        nrTelefone,
        idAgendamento: agendamentoSelecionado.data?.[0],
        dsMensagem: mensageSendWhats,
      },
      'CtrlAgendamento',
    )
    if (result.status) {
      setOpenConfirmModal(false)
      setSuccess('Mensagem enviada com sucesso!')
    }
  }

  const reabrirAgendamento = (idAgendamento) => {
    metodoPrograma('reabrirAgendamento', {
      idAgendamento,
      idLocalAtendimento: localAtendimento[0],
    }).then((res) => {
      if (res.status) {
        fecharModal()
      }
    })
  }

  const confirmaStatusAgendamento = async ({
    metodo,
    titulo,
    descricao,
    textoConfirmar,
  }) => {
    await openModalSenha({
      metodo,
      idAgendamento,
      titulo,
      descricao,
      textoConfirmar,
      onSuccess: fecharModal,
    })
  }

  return (
    <div className="flex justify-end w-full gap-2">
      {idAgendamento && (
        <>
          {dtExclusao ? (
            <Button
              fullWidth
              startIcon={<IoReload />}
              variant="contained"
              onClick={async () => cancelaAgendamento(idAgendamento)}
            >
              Reativar
            </Button>
          ) : (
            !dtConfirmouComparecimento &&
            Number(usuarioLogado?.id) !== 45 && (
              <IconButton
                title="Excluir"
                color="error"
                size="small"
                sx={{ padding: 0 }}
                onClick={async () => cancelaAgendamento(idAgendamento)}
              >
                <BiTrash />
              </IconButton>
            )
          )}
        </>
      )}
      {idAgendamento && !dtConfirmouComparecimento && (
        <>
          <Button
            type="button"
            variant="contained"
            color="error"
            size="small"
            sx={{ flex: '1 1 0', minWidth: 0 }}
            onClick={() =>
              confirmaStatusAgendamento({
                metodo: 'confirmaNaoRealizacao',
                titulo: 'Confirmar não realização',
                descricao:
                  'Digite sua senha numérica de 6 dígitos para confirmar que o atendimento não foi realizado.',
                textoConfirmar: 'Confirmar não realização',
              })
            }
          >
            Não Realizado
          </Button>
          <Button
            type="button"
            variant="contained"
            color="success"
            size="small"
            sx={{ flex: '1 1 0', minWidth: 0 }}
            onClick={() =>
              confirmaStatusAgendamento({
                metodo: 'confirmaRealizacao',
                titulo: 'Confirmar realização',
                descricao:
                  'Digite sua senha numérica de 6 dígitos para confirmar que o atendimento foi realizado.',
                textoConfirmar: 'Confirmar realização',
              })
            }
          >
            Realizado
          </Button>
        </>
      )}
      {!dtExclusao && tpEstado !== '6' && (
        <Button
          variant="contained"
          color="primary"
          type="submit"
          startIcon={<LuSave />}
          sx={{ flex: '1 1 0', minWidth: 0 }}
        >
          Salvar
        </Button>
      )}
      {!dtExclusao && tpEstado === '6' && (
        <Button
          fullWidth
          startIcon={<FaPersonCircleCheck />}
          variant="contained"
          color="primary"
          onClick={() => reabrirAgendamento(idAgendamento)}
        >
          Reabrir
        </Button>
      )}
      <Dialog
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
      >
        <DialogTitle>Confirmar Envio da mensagem:</DialogTitle>
        <DialogContent>
          <p>{mensageSendWhats}</p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenConfirmModal(false)}
            color="error"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSendWhatsApp}
            color="primary"
            variant="contained"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
